import React, {Component} from 'react';
import {ChangeStateMessage} from "../business_units/ChangeStateMessage";
import {SaveButton} from "../business_units/SaveButton";
import {YesNoModal} from "./YesNoModal";

export class SaveBar extends Component {
    yesNoModalRef = React.createRef();

    closeSaveModal() {
        if (this.yesNoModalRef.current) {
            this.yesNoModalRef.current.toggle();
        }
    }

    renderSaveButton() {
        if (this.props.userConfirmationNeeded) {
            return <YesNoModal
                ref={this.yesNoModalRef}
                onYesAnswer={this.props.onClick}
                title={this.props.title}
                message={this.props.message}
                question={this.props.question}
                buttonClassName={this.buttonClass()}
                buttonText="Guardar"
                buttonStyle={this.buttonStyle()}
                buttonIconName={""}
                isSaving={this.props.isSaving}
            />
        } else {
            return <SaveButton onClick={this.props.onClick} isSaving={this.props.isSaving}
                               hasChanges={this.props.hasChanges}/>
        }
    }

    render() {
        return (
            <div className="save-changes-bar">
                <ChangeStateMessage hasChanges={this.props.hasChanges}/>
                {this.renderSaveButton()}
            </div>
        )
    }

    buttonClass() {
        if (this.props.hasChanges) {
            return "btn -alt"
        } else {
            return "btn -alt disabled"
        }
    }

    buttonStyle() {
        if (!this.props.hasChanges) {
            return {pointerEvents: "none"}
        }
    }
}
